import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as AppleAuthentication from 'expo-apple-authentication';
import { View } from 'modules/styled';
import { appleLogin, setPreUser, checkUser } from './auth.actions';
import jwtDecode from 'jwt-decode';
import { Alert } from 'react-native';

AppleLogin.propTypes = {
  isLogin: PropTypes.bool,
  navigation: PropTypes.object,
};

export function AppleLogin({ isLogin, navigation }) {
  const dispatch = useDispatch();
  return (
    <View sx={{ flex: 1, borderColor: 'black', borderWidth: 1 }}>
      <AppleAuthentication.AppleAuthenticationButton
        buttonType={AppleAuthentication.AppleAuthenticationButtonType.SIGN_IN}
        buttonStyle={AppleAuthentication.AppleAuthenticationButtonStyle.WHITE}
        cornerRadius={0}
        style={{ height: 44 }}
        onPress={async () => {
          try {
            const credential = await AppleAuthentication.signInAsync({
              requestedScopes: [AppleAuthentication.AppleAuthenticationScope.EMAIL],
            });
            const { identityToken } = credential;
            const { email } = jwtDecode(identityToken);
            if (isLogin) return dispatch(appleLogin(identityToken));

            const emailExists = await dispatch(checkUser(email, 'email'));
            if (emailExists)
              return Alert.alert('This email has already been used - try logging in');
            dispatch(setPreUser({ email, identityToken }));
            navigation.navigate({ routeName: 'signup' });
            // signed in
          } catch (e) {
            // console.log(e);
            // if (e.code === 'ERR_CANCELED') {
            //   // handle that the user canceled the sign-in flow
            // } else {
            //   // handle other errors
            // }
          }
        }}
      />
    </View>
  );
}
